module.exports = __webpack_public_path__ + "static/media/jlt_logo_2023.645c3efc.svg";